import { precompileTemplate } from "@ember/template-compilation";
export default precompileTemplate("<Saas::SaasSharedUiShim @componentName=\"PreviewBanner\" @variant={{this.variant}} @feature={{this.feature}} @shimTag={{this.shimTag}} @className={{this.className}} />", {
  moduleName: "@dashboard/shared-ui/components/saas/preview-banner.hbs"
});